import axios from "axios";
import Keycloak from "keycloak-js";
import keycloakConfig from "../config/keycloak.json";

/**
 * Se hace el mapping a la configuración que espera el keycloak.js
 */
let kc = keycloakConfig;
kc.url = kc["auth-server-url"];
kc.clientId = kc["resource"];

/**
 * Se encarga de registrar e inicializar la aplicación y
 * el mecanismo de seguirdad.
 *
 */
class KeycloakHelper {
  loggedIn = false;

  keycloak = new Keycloak(kc);

  initAxios() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.keycloak.token;
    // Add a response interceptor
    axios.interceptors.response.use(response => response, function(error) {
      if (error.response.status === 401) {
        console.error("refresh token");
      }
      return Promise.reject(error);
    });
  }
  /**
   * Se encarga de inicializar contexto de seguridad con keycloak.
   */
  init(callback) {
    this.loggedIn = false;
    this.keycloak
      .init({
        onLoad: "check-sso"
      })
      .success(() => {
        this.loggedIn = this.keycloak.authenticated;
        if (this.loggedIn) {
          this.initAxios();
        }
        callback();
      })
      .error(() => {
        window.location.reload();
      });
  }
  
  /**
   * Dispara el login del keycloak
   */
  login() {
    this.keycloak.login();
  }

  /**
   * Dispara el logout del keycloak
   */
  logout() {
    this.keycloak.logout();
  }
}

export default new KeycloakHelper();
